import { Box } from '@chakra-ui/react';
import React from 'react';

import { CreditAgreementsViewTemplate } from 'capitalProvider/domains/credit-agreements/ui/CreditAgreementsViewTemplate';
import { dashboardRoutePadding } from 'packages/common-frontend/constants';
import CreditAgreement from 'packages/creditAgreements/ui/CreditAgreementView';

export const CreditAgreementRoute = ({
  disableSelectors,
  creditAgreementId,
}: {
  disableSelectors: boolean;
  creditAgreementId: string;
}) => {
  return (
    <Box padding={dashboardRoutePadding}>
      <CreditAgreementsViewTemplate disableSelectors={disableSelectors}>
        <CreditAgreement
          creditAgreementId={creditAgreementId}
          creditAgreementsPath="/credit-agreements"
        />
      </CreditAgreementsViewTemplate>
    </Box>
  );
};
